export class HelpContentsFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getHelpContents(filter) {
    return this.instance.get('/v1/help-contents', {
      params: filter || null,
    });
  }

  getHelpContent(id, filter) {
    return this.instance.get(`/v1/help-contents/${id}`, {
      params: filter || null,
    });
  }

  insertHelpContent(data) {
    return this.instance.post('/v1/help-contents', data, {
      timeout: 120000,
    });
  }

  editHelpContent(data, id) {
    return this.instance.put(`/v1/help-contents/${id}`, data, {
      timeout: 120000,
    });
  }

  deleteHelpContent(id) {
    return this.instance.delete(`/v1/help-contents/${id}`);
  }
}

export default (...params) => new HelpContentsFactory(...params);
